import { createEventBus } from 'n8n-design-system/utils';

export const globalLinkActionsEventBus = createEventBus();
